__turbopack_context__.v({
  "count": "tracker-suggested-drugs-module__BQmqLq__count",
  "footer": "tracker-suggested-drugs-module__BQmqLq__footer",
  "glyph": "tracker-suggested-drugs-module__BQmqLq__glyph",
  "grid": "tracker-suggested-drugs-module__BQmqLq__grid",
  "indication": "tracker-suggested-drugs-module__BQmqLq__indication",
  "name": "tracker-suggested-drugs-module__BQmqLq__name",
  "nameBlock": "tracker-suggested-drugs-module__BQmqLq__nameBlock",
  "raised": "tracker-suggested-drugs-module__BQmqLq__raised",
  "root": "tracker-suggested-drugs-module__BQmqLq__root",
  "rootFlushTop": "tracker-suggested-drugs-module__BQmqLq__rootFlushTop",
  "row": "tracker-suggested-drugs-module__BQmqLq__row",
  "tab": "tracker-suggested-drugs-module__BQmqLq__tab",
  "tabActive": "tracker-suggested-drugs-module__BQmqLq__tabActive",
  "tabs": "tracker-suggested-drugs-module__BQmqLq__tabs",
});
